import { EnvironmentTermsPlacement } from '../enums';

export const EnvironmentTermsPlacements = [
  { name: 'Funds summary and fund detail', value: EnvironmentTermsPlacement.LastPage },
  { name: 'Funds summary and footer', value: EnvironmentTermsPlacement.Footer },
];
